import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import ActivitiesPanelFull from './ActivitiesPanelFull';
import ActivitiesPanelNarrow from './ActivitiesPanelNarrow';

const ActivitiesPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: ActivitiesPanelFull, narrow: ActivitiesPanelNarrow }}
  />
);

export default ActivitiesPanel;
